import { ProfileType } from '@ixicare/resources';
import * as React from 'react';
import { t } from '~/i18n';
import UserProfileEntry from '~store/Profile/UserProfileEntry';
import ProfileFormContainer from '../Profile/ProfileForm';
import { Permission } from '@ixicare/resources';

interface HealthcareProviderFormContainerProps {
  healthcareProvider?: UserProfileEntry;
}

const HealthcareProviderFormContainer: React.FC<HealthcareProviderFormContainerProps> = ({ healthcareProvider }) => {
  const [creationPermission, setCreationPermission] = React.useState<boolean>(false);

  React.useEffect(() => {
    Permission.getOwnPermissions().then((perm) => {
      if (perm.length != 0) {
        perm[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_create_profiles')) {
            if (perm.isEnabled) {
              setCreationPermission(true);
            }
          }
        });
      }
    });
  }, []);
  return creationPermission ? (
    <ProfileFormContainer
      profileType={ProfileType.HealthcareProvider}
      fields={['email', 'password']}
      profile={healthcareProvider}
      urlPath="healthcare-providers"
      storeType={'healthcareProviders'}
      passwordRequired
      donePath={'/healthcare-providers'}
    />
  ) : (
    <p>{t('user-configuration.no-permissions')}</p>
  );
};

export default HealthcareProviderFormContainer;
